export const RULE_FIRED_TYPE = 'RuleFired';
